import { render } from "./TrainingMain.vue?vue&type=template&id=64c652d2"
import script from "./TrainingMain.vue?vue&type=script&lang=js"
export * from "./TrainingMain.vue?vue&type=script&lang=js"

import "./TrainingMain.vue?vue&type=style&index=0&id=64c652d2&lang=css"

import exportComponent from "D:\\project\\survey-slp-house\\survey-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__